<template lang="html">
    <span
        class="lightest px-2 py-1 fs-normal radius-normal"
        :class="bgColor"
    >
        {{getPaymentState(paymentStateCode).label}}
    </span>
</template>

<script>
import {mapGetters} from 'vuex'
import { reservationsMixin } from '@/mixins/reservations'
export default {
    mixins: [reservationsMixin],
    props: {
        reservation: {
            type: Object
        }
    },
    computed: {
        ...mapGetters([
            'getPaymentState',
            'getReservationCalculations'
        ]),
        bgColor: function () {
            return 'bg-'+this.getPaymentState(this.paymentStateCode).color
        },
        atLeastOneRefundCodeToBeConfirmed() {
            // test if we have or not, at least one refund code to be confirmed/aprooved
            return this.reservation.refunds.some( r => r.isCodeConfirmed )
        },
        paymentStateCode: function () {
            return this.getReservationCalculations.paymentStatus;
        },
    }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// PaymentStatusBtn.vue?2d873238